<script>
import IconSvg from './IconSvg';

export default {
  components: { IconSvg },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    return {
      onclose() {
        emit('close');
      },
    };
  },
  render(createElement, context) {
    return (
      <div class="notifications-header">
        {this.title}
        <i class="pb-icon-close notifications-header-close" onClick={this.onclose} />
      </div>
    );
  },
};
</script>
<style lang="scss" scoped>
$prefix: 'notifications-header';
@mixin notifications($fix) {
  $p: $prefix + '-' + $fix;
  .#{$p} {
    @content;
  }
}

.#{$prefix} {
  position: relative;
  height: 56px;
  line-height: 56px;
  font-size: 16px;
  padding-left: 16px;
  border-bottom: 1px solid #e9eaee;
  font-family: DiDiSansPro, SF Pro Text, PingFang SC, PingFang TC, Meiryo, Microsoft Sans Serif, Microsoft YaHei, Microsoft JhengHei, Helvetica Neue, Helvetica, Arial, Sans-serif;
  @include notifications(close) {
    font-size: 16px;
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
}
</style>
